import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { FillScreen } from "@/components/Layout";
import { LIST_EMPTY_DATA } from "@/lib/listPage";

import DataTableCard from "./-components/DataTableCard";
import FilterBarButtons from "./-components/FilterBarButtons";
import FilterBarTabs from "./-components/FilterBarTabs";
import useGetProductPermissions from "./-queries/useGetProductPermissions";
import useGetProductPermissionsCount from "./-queries/useGetProductPermissionsCount";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/settings/permission-and-roles/_list/product-permissions/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const { data: productPermissionsRes, isPending } = useGetProductPermissions({
    search,
  });

  const { data: countRes } = useGetProductPermissionsCount({ search });

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <FilterBarTabs search={search} navigate={navigate} countRes={countRes} />

      <FilterBarButtons search={search} navigate={navigate} />

      <DataTableCard
        search={search}
        navigate={navigate}
        productPermissionsRes={productPermissionsRes ?? LIST_EMPTY_DATA}
        isPending={isPending}
      />
    </FillScreen>
  );
}
